import React, { Component } from 'react';
import './DotLoader.scss';
import anime from 'animejs';
import { COLORMAP } from '../styles';

const COLORS = [COLORMAP.pink, COLORMAP.orange, COLORMAP.yellow, COLORMAP.teal];
const ANIMATION_DURATION = 500;

class DotLoader extends Component {
  currentDot = 0;
  dots = [null, null, null, null];

  componentDidMount() {
    anime({
      targets: this.dots,
      loop: true,
      duration: ANIMATION_DURATION,
      easing: 'easeInQuad',
      translateY: [ { value: -30 }, { value: 0 }],
      backgroundColor: [ { value: (el, i) => COLORS[i], duration: ANIMATION_DURATION * 0.3 }, { value: '#ffffff', duration: ANIMATION_DURATION }],
      delay: (el, i) => i * 300
    });
  }

  render() {
    return (
      <div className="dot-loader">
        <div className="dots">
          <div ref={ref => this.dots[0] = ref} className="dot" />
          <div ref={ref => this.dots[1] = ref} className="dot" />
          <div ref={ref => this.dots[2] = ref} className="dot" />
          <div ref={ref => this.dots[3] = ref} className="dot" />
        </div>
        {this.props.label}
      </div>
    );
  }
}

export { DotLoader };


// WEBPACK FOOTER //
// ./src/components/DotLoader.js